// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file primary_login_device.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file primary_login_device.proto.
 */
export const file_primary_login_device: GenFile = /*@__PURE__*/
  fileDesc("ChpwcmltYXJ5X2xvZ2luX2RldmljZS5wcm90bxIGZG9tYWluKr4BChJQcmltYXJ5TG9naW5EZXZpY2USIAocUFJJTUFSWV9MT0dJTl9ERVZJQ0VfVU5LTk9XThAAEh0KGVBSSU1BUllfTE9HSU5fREVWSUNFX05PTkUQARIeChpQUklNQVJZX0xPR0lOX0RFVklDRV9QSE9ORRACEiUKIVBSSU1BUllfTE9HSU5fREVWSUNFX1NFQ1VSSVRZX0tFWRADEiAKHFBSSU1BUllfTE9HSU5fREVWSUNFX1NFUlZJQ0UQBEIwWi5naXRsYWIuY29tL2NvdGVjaGRlL21vbm9yZXBvL2JhY2tlbmQvZG9tYWluL3BiYgZwcm90bzM");

/**
 * @generated from enum domain.PrimaryLoginDevice
 */
export enum PrimaryLoginDevice {
  /**
   * @generated from enum value: PRIMARY_LOGIN_DEVICE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: PRIMARY_LOGIN_DEVICE_NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: PRIMARY_LOGIN_DEVICE_PHONE = 2;
   */
  PHONE = 2,

  /**
   * @generated from enum value: PRIMARY_LOGIN_DEVICE_SECURITY_KEY = 3;
   */
  SECURITY_KEY = 3,

  /**
   * @generated from enum value: PRIMARY_LOGIN_DEVICE_SERVICE = 4;
   */
  SERVICE = 4,
}

/**
 * Describes the enum domain.PrimaryLoginDevice.
 */
export const PrimaryLoginDeviceSchema: GenEnum<PrimaryLoginDevice> = /*@__PURE__*/
  enumDesc(file_primary_login_device, 0);

